import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../../shared/utils/utils";
import { RootState } from "../../../shared/types/common";
import { Drawer } from "antd";
import GenericFormComponent from "../../../shared/components/generic-form/generic-form.component";
import { useForm } from "antd/lib/form/Form";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  createDepartment,
  updateDepartmentById,
} from "../../../core/store/reducers/department.slice";
import { Client } from "../../../core/api-client";
import {
  API_GET_ALL_DEPARTMENT_LIST,
  API_GET_ALL_STAFF_LIST,
} from "../../../shared/routes/private.routes";
import {
  createSubDepartment,
  updateSubDepartmentById,
} from "../../../core/store/reducers/sub-department.slice";

interface Props {
  onClose: () => void;
  visible: boolean;
  selectedEntity?: any;
  onSubmit?: () => void;
}
const CreateEditSubDepartmentComponent = ({
  onClose,
  visible,
  selectedEntity = null,
  onSubmit = () => {
    return;
  },
}: Props) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const { user } = useSelector((state: RootState) => state.auth);
  const { screenType } = useSelector((state: RootState) => state.settings);
  const [staffList, setStaffList] = useState<any[]>([]);
  const [departmentList, setDepartmentList] = useState<any[]>([]);

  const onFinish = (values: any) => {
    const payload = {
      subDepartmentName: values?.subDepartmentName,
      departmentId: values?.department,
      ownerId: values?.subDepartmentOwner,
      status: values?.status,
    };
    if (selectedEntity) {
      dispatch(
        updateSubDepartmentById({
          subDepartmentId: selectedEntity?.id,
          body: payload,
        })
      ).then((val: any) => {
        if (val?.payload?.data) {
          showNotification(
            "Sub Department Details Updated Successfully",
            "success"
          );
          onSubmit();
        }
      });
    } else {
      dispatch(createSubDepartment(payload)).then((val: any) => {
        if (val?.payload?.data) {
          showNotification(
            "New Sub Department Created Successfully",
            "success"
          );
          onSubmit();
        }
      });
    }
  };

  const fetchStaffList = async () => {
    const response = await Client.get(API_GET_ALL_STAFF_LIST);
    if (response?.data?.data) {
      setStaffList(response?.data?.data);
    } else {
      setStaffList([]);
    }
  };

  const fetchDepartmentList = async () => {
    const response = await Client.get(API_GET_ALL_DEPARTMENT_LIST);
    if (response?.data?.data) {
      setDepartmentList(response?.data?.data);
    } else {
      setDepartmentList([]);
    }
  };

  useEffect(() => {
    if (selectedEntity) {
      form.setFieldsValue({
        subDepartmentName: selectedEntity?.subDepartmentName,
        department: selectedEntity?.departmentId,
        subDepartmentOwner: selectedEntity?.ownerId,
        status: selectedEntity?.status,
      });
    }
  }, [form, selectedEntity]);

  useEffect(() => {
    fetchStaffList();
    fetchDepartmentList();
  }, []);

  const dropdownOptions = staffList.map((staff) => ({
    value: staff?.staffId, // Assuming 'id' is the unique identifier
    label: staff?.staffName, // Assuming 'name' is the display name
  }));

  const departmentDropdownOptions = departmentList.map((department) => ({
    value: department?.departmentId,
    label: department?.departmentName,
  }));

  const onFinishFailed = (_errorInfo: any) => {
    return;
  };

  const onValuesChange = (changedValues: any, _allValues: any) => {
  };

  var colSpan = screenType.isPortrait ? 24 : 12;
  const formProps = {
    form: form,
    name: "creat-edit-sub-department",
    heading: selectedEntity
      ? "Edit Sub Department Details"
      : "Add New Sub Department",
    initialValues: {
      status: "ACTIVE",
    },
    formElements: [
      {
        name: "subDepartmentName",
        colSpan: 12,
        label: "Sub Department Name",
        placeholder: "Enter Sub Department Name ",
        type: "Input",
        allowClear: true,
        rules: [
          { required: true, message: "Please enter Sub Department Name" },
        ],
      },
      {
        name: "department",
        colSpan: 12,
        label: "Department",
        placeholder: "Select Department ",
        type: "Select",
        allowClear: true,
        options: departmentDropdownOptions,
        rules: [{ required: true, message: "Please Select Department" }],
      },
      {
        name: "status",
        label: "Status",
        placeholder: "Status",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: [
          { value: "ACTIVE", label: "ACTIVE" },
          { value: "INACTIVE", label: "INACTIVE" },
        ],
        rules: [{ required: true, message: "Please enter Status" }],
      },
      {
        name: "subDepartmentOwner",
        label: "Sub Department Owner",
        placeholder: "Sub Department Owner",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: dropdownOptions,
        rules: [
          { required: true, message: "Please select Sub Department Owner" },
        ],
      },
    ],
    extraButtons: [
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Cancel",
        onClick: onClose,
      },
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpan: 5,
        loading: false,
        submitButtonText: "Save",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange,
  };
  return (
    <>
      <Drawer
        maskClosable={false}
        title={<strong>{formProps.heading}</strong>}
        className="form-drawer"
        width={
          screenType.isPortrait
            ? "90%"
            : screenType.isLg || screenType.isXl
            ? 720
            : 500
        }
        onClose={onClose}
        open={visible}
      >
        <GenericFormComponent {...formProps} />
      </Drawer>
    </>
  );
};

export default CreateEditSubDepartmentComponent;
